<template>
    <BreadCrumb PageTitle="Modifier une mandature" />
    <EditMandature />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import EditMandature from "@/components/Mandatures/EditMandature.vue";
  
    export default defineComponent({
      name: "EditMandaturePage",
      components: {
        BreadCrumb,
        EditMandature,
      },
    });
  </script>